module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "warehouse-modal",
    attrs: {
      "before-close": _vm.closeModal,
      "visible": _vm.openModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "modal-title d-flex align-center",
    style: (("background-color:" + (_vm.globalColors.primary)))
  }, [(_vm.showMap) ? _c('el-button', {
    staticClass: "arrow-back",
    attrs: {
      "icon": "el-icon-back"
    },
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "modal-title-text"
  }, [_vm._v(_vm._s(_vm.modalTitle))])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "go-left",
      "mode": "out-in",
      "tag": "div"
    }
  }, [(_vm.showMap) ? _c('section', {
    key: "map",
    staticClass: "map"
  }, [_c('p', [_c('span', [_c('b', [_vm._v(_vm._s(_vm.selectedWarehouse.autocomplete) + ": ")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.selectedWarehouse.warehouse.address))])]), _vm._v(" "), _c('map-component', {
    attrs: {
      "location": _vm.warehouseLocation
    }
  })], 1) : _c('section', {
    key: "warehouse-table",
    staticClass: "table"
  }, [_c('div', {
    staticClass: "header grid-sistem"
  }, _vm._l((_vm.columns), function(column) {
    return _c('span', {
      key: column.title
    }, [_vm._v(_vm._s(column.title))])
  })), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.rows), function(row, indexRow) {
    return _c('div', {
      key: indexRow,
      staticClass: "row grid-sistem"
    }, [_c('span', [_c('span', {
      staticClass: "warehouse-name"
    }, [_vm._v(_vm._s(row.warehouse.name)), _c('br')]), _vm._v(" "), _c('span', {
      staticClass: "warehouse-address"
    }, [_vm._v(_vm._s(row.warehouse.address))])]), _vm._v(" "), _c('span', {
      class: {
        'stock-cero': row.stock === 0
      }
    }, [_vm._v(_vm._s(row.stock))]), _vm._v(" "), (_vm.warehouseLatLon(row)) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.goToMap(row)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/icons/map.svg",
        "alt": "mapa"
      }
    })]) : _vm._e()])
  }))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35339809","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/warehouseModal.vue
// module id = 1090
// module chunks = 1